// extracted by mini-css-extract-plugin
module.exports = {"pill":"_37237caf"};